import React from 'react';
import { Select } from 'antd';

import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
const { Option } = Select;
const CheckInsActionView = () => {
  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <Select
        className='apphome-display-btn'
        placeholder='New Check-in'
        style={{ width: '156px' }}
      >
        <Option style={{ pointerEvents: 'none' }}>
          <PlusOutlined /> Daily Standup
        </Option>
        <Option style={{ pointerEvents: 'none' }}>
          <PlusOutlined /> Retrospective
        </Option>
        <Option style={{ pointerEvents: 'none' }}>
          <PlusOutlined /> Retrospective Anonymous
        </Option>
        <Option style={{ pointerEvents: 'none' }}>
          <PlusOutlined /> Task Check-in
        </Option>
        <Option style={{ pointerEvents: 'none' }}>
          <PlusOutlined /> Planning Poker
        </Option>
        <Option style={{ pointerEvents: 'none' }}>
          <PlusOutlined /> Team Mood
        </Option>
        <Option style={{ pointerEvents: 'none' }}>
          <PlusOutlined /> Team Mood Anonymous
        </Option>
      </Select>
    </div>
  );
};

export default CheckInsActionView;
